module.exports = {
	"pl": {
		"help-tool": {
			"button-text": "Pomoc",
			"support-button": "Uzyskaj wsparcie",
			"support-page": {
				"create-ticket": {
					"title": "Uzyskaj wsparcie",
					"instructions": "Wyślij zapytanie poniżej, a my skontaktujemy się z Tobą w ciągu jednego dnia roboczego.",
					"related-content": {
						"title": "To może pomóc rozwiązać Twój problem"
					},
					"fields": {
						"mid": {
							"label": "Wybierz sklep",
							"validation": "Wymagany sklep"
						},
						"phoneNumber": {
							"label": "Numer telefonu (opcjonalnie)"
						},
						"topic": {
							"question": "Czego dotyczy Twoje pytanie?",
							"label": "Wybierz temat",
							"validation": "Wymagany temat",
							"options": {
								"orders": "Zamówienia",
								"settlements": "Rozliczenia",
								"agreements": "Umowy",
								"others": "Inny"
							}
						},
						"subject": {
							"label": "Temat",
							"validation": "Wymagany temat"
						},
						"description": {
							"label": "Wiadomość",
							"validation": "Wymagany opis"
						},
						"attachment": {
							"label": "Dodaj załączniki",
							"button": "Prześlij",
							"info": "Dodanie zrzutów ekranu pomoże nam szybciej rozwiązać problem.",
							"supportedFileTypes": "Obsługiwane typy plików: .png, .jpg, .pdf",
							"error": "Łączny rozmiar plików nie może przekraczać {maxSize} MB"
						}
					},
					"submit": "Wyślij zapytanie",
					"service-unavailable-error": "Ups! Wystąpił błąd. Spróbuj ponownie za kilka minut. Jeśli to będzie się powtarzać, {link} w celu uzyskania pomocy.",
					"generic-error": "Nie mogliśmy przetworzyć Twojego zapytania. Nasze systemy nie komunikują się ze sobą w tej chwili. Spróbuj odświeżyć lub wróć później. Jeśli to będzie się powtarzać, {link} w celu uzyskania pomocy.",
					"contact-link": "skontaktuj się z nami"
				},
				"view-ticket": {
					"title": "Wszystko gotowe!",
					"details": "Otrzymaliśmy Twoje zapytanie – odpowiemy w ciągu jednego dnia roboczego. Oto szczegóły:",
					"ticket": "Zapytanie #{ticketId}",
					"email": "E-mail: {email}",
					"status": "Możesz śledzić status na naszej stronie Wsparcia.",
					"track": "Śledź status"
				}
			},
			"header": {
				"homeLink": "Zresetuj"
			},
			"home": {
				"greeting": "Witamy, {givenName}! Jak możemy Ci pomóc?",
				"topics": "W czym potrzebujesz pomocy?"
			},
			"topics": {
				"expandButton": "Więcej"
			},
			"feedback": {
				"title": "Czy to pomogło?",
				"optionYes": "Tak, pomogło",
				"optionNo": "Nie, nadal potrzebuję pomocy",
				"positiveFeedback": "Dziękujemy za pozytywną opinię, dzięki temu w przyszłości będziemy mogli proponować Ci lepiej dopasowane artykuły."
			},
			"freeTextFeedback": {
				"title": "Pomóż nam się poprawić",
				"placeholder": "Dlaczego te treści nie były przydatne?",
				"submitButton": "Wyślij",
				"feedbackMessage": "Dziękujemy za Twoją opinię, dzięki temu w przyszłości będziemy mogli proponować Ci lepiej dopasowane artykuły."
			},
			"relatedContent": {
				"title": "Powiązane treści"
			},
			"search": {
				"buttonLabel": "Szukaj",
				"input": "Szukaj artykułów...",
				"loading": "Ładowanie...",
				"results": {
					"contact": "Nie możesz znaleźć potrzebnej pomocy?",
					"empty": "Przepraszamy, brak wyników dla Twojego zapytania. Spróbuj wyszukać inny wyraz.",
					"singleTopicFound": "Znalezione tematy: 1",
					"multipleTopicsFound": "Znalezione tematy: {count}",
					"singleArticleFound": "Znalezione artykuły: 1",
					"multipleArticlesFound": "Znalezione artykuły: {count}"
				}
			},
			"contact": {
				"title": "Skontaktuj się z nami",
				"channelsIntro": "Zwróć się do nas, abyśmy mogli Ci pomóc.",
				"businessDetailsTitle": "Dane dotyczące Twojej firmy",
				"businessDetailsName": "Nazwa firmy",
				"businessDetailsEmail": "E-mail",
				"businessDetailsMid": "ID sprzedawcy",
				"phone": {
					"title": "Zadzwoń do nas",
					"paragraph": "Możesz do nas dzwonić w godzinach pracy w dni powszednie. Jeśli jesteś w Szwecji lub Zjednoczonym Królestwie, możesz do nas dzwonić także w weekendy w godzinach 10–16."
				},
				"email": {
					"title": "Napisz do nas e-mail",
					"paragraph": "Wyślij nam e-mail, a my odezwiemy się do Ciebie jak najszybciej."
				}
			},
			"errorBoundary": {
				"title": "Wystąpił błąd",
				"message": "Bardzo przepraszamy, ale wystąpił błąd. Możesz kliknąć przycisk „Wstecz” poniżej, aby powrócić do narzędzia pomocy lub „Uzyskaj wsparcie”, aby skontaktować się z nami,",
				"resetButton": "Wstecz",
				"errorId": "Identyfikator błędu: {errorId}"
			},
			"tour": {
				"prev": "Wstecz",
				"next": "Dalej",
				"done": "Gotowe"
			},
			"notAvailableMobile": {
				"title": "Niedostępne",
				"buttonBack": "Wstecz",
				"paragraph": "Ta treść nie jest dostępna na Twoim urządzeniu. Spróbuj otworzyć na urządzeniu o większym ekranie, np. na komputerze stacjonarnym."
			},
			"shareButton": {
				"title": {
					"article": "Udostępnij głęboki link do tego artykułu",
					"topic": "Udostępnij głęboki link do tego tematu",
					"tour": "Udostępnij głęboki link do tego przewodnika"
				},
				"radioItemHome": "Strona główna aplikacji",
				"descriptionHome": "Otwiera artykuł pomocy na stronie głównej Portalu dla handlowców",
				"radioItemCurrent": "Bieżąca strona",
				"descriptionCurrent": "Otwiera artykuł pomocy na bieżącej stronie"
			},
			"marketSelector": {
				"whichMarketToContact": "Z którym rynkiem chcesz się skontaktować?"
			}
		},
		"orientation": {
			"title": "Dowiedz się, jak..."
		},
		"helpbot": {
			"questions": {
				"whatDoYouNeedHelpWithPart1": "Cześć, {name}! 👋 Jestem Twoim asystentem Klarna.",
				"whatDoYouNeedHelpWithPart2": "Często potrafię odpowiedzieć na zapytanie w mniej niż 5 minut.",
				"whatDoYouNeedHelpWithPart3": "W czym mogę Ci dzisiaj pomóc?",
				"selectSupportChannel": "Wybierz kanał, aby skontaktować się z naszym działem wsparcia.",
				"selectPayoutIssue": "Super! Przejdź dalej i wybierz sprawę związaną z wypłatami 👇",
				"selectOrderIssue": "Super! Przejdź dalej i wybierz sprawę związaną z zamówieniami 👇",
				"capturedOrders": "Czy masz jakieś {link1} zamówienia?",
				"capturedOrdersLink1": "przyjęte",
				"notPaidOrder": {
					"isScheduleFollowed": "Czy Twój {link1} (w tym opóźnienie wypłaty) jest przestrzegany?",
					"isScheduleFollowedLink1": "harmonogram wypłat",
					"isHoldbackOrDebt": "Jeśli wypłata jest opóźniona sprawdź swój {link1}. Czy jest jakieś wstrzymanie lub zadłużenie z powodu zwrotów/storna?",
					"isHoldbackOrDebtLink1": "ostatni plik rozliczenia"
				},
				"paidWrongAmount": {
					"isScheduleFollowed": "Prosimy o zweryfikowanie daty przyjęcia zamówień, dla których spodziewano się wypłaty i uwzględnienie opóźnienia w wypłacie. Możesz znaleźć swoje zamówienia {link1}. Czy zamówienia, które oczekują na wypłatę, zostały przyjęte?",
					"isScheduleFollowedLink1": "tutaj"
				},
				"changePaymentFrequency": "Czy w okresie 3 miesięcy przyjęto więcej niż 30 zamówień miesięcznie?",
				"whenWillGetPaid": "Termin wypłaty będzie zależeć od Twoich zaplanowanych wypłat i opóźnienia wypłaty określonego w umowie (Warunki i regulamin). Jeśli nie masz pewności, jaka jest konfiguracja wypłaty, możesz to sprawdzić w {link1}. Czy harmonogram wypłat (+opóźnienie wypłat) jest przestrzegany?",
				"whenWillGetPaidLink1": "Rozliczenia",
				"thatHelped": "Dziękujemy za pozytywną opinię, dzięki temu w przyszłości będziemy mogli proponować Ci lepiej dopasowaną pomoc. 😀",
				"orders": {
					"haveUncapturedOrdersPart1": "Ach, rozumiem! Czy masz jakieś nieprzyjęte zamówienia?",
					"haveUncapturedOrdersPart2": "Jeśli nie wiesz, jak to sprawdzić, przejdź do {link1}.",
					"haveUncapturedOrdersPart2Link1": "tę stronę",
					"expirationDateSurpassed": "Czy minął termin ważności? (zwykle 28 dni)",
					"customerCreditPaymentMethod": "Czy klient wybrał kredytową formę płatności (faktura, rachunek, polecenie zapłaty)?",
					"isOrderCaptured": "Czy zamówienie zostało {link1}?",
					"isOrderCapturedLink1": "przyjęte"
				}
			},
			"options": {
				"payout": "Wypłata",
				"orders": "Zamówienia",
				"otherIssue": "Inne sprawy",
				"whenPaidOrderNext": "Kiedy otrzymam następną wypłatę?",
				"notPaidOrder": "Nie mam wypłaty",
				"paidWrongAmount": "Zapłacono mi niewłaściwą kwotę",
				"changeHowOftenPaid": "Chcę zmienić częstotliwość otrzymywania wypłat",
				"dontKnowHowToCaptureOrder": "Nie wiem jak przyjąć zamówienie",
				"missedCaptureDeadline": "Termin przyjęcia został przeze mnie przegapiony",
				"needToRefundAnOrder": "Chcę otrzymać zwrot pieniędzy za zamówienie",
				"yes": "Tak",
				"no": "Nie",
				"partially": "Częściowo",
				"iNeedMoreHelp": "Potrzebuję jeszcze pomocy",
				"thatHelped": "To było pomocne",
				"contactSupportChannel": "Skontaktuj się z kanałami wsparcia"
			},
			"explanations": {
				"noCapturedOrders": "Po pierwsze, musisz {link1}. Po przyjęciu zamówienia wypłacimy kwotę na Twoje konto bankowe. Opłaty, zwroty i inne koszty zostaną odjęte od tej kwoty.",
				"noCapturedOrdersLink1": "przyjąć zamówienie",
				"feesReturnsHoldbacks": "Opłaty, zwroty i inne koszty mogą zostać odjęte od kwoty wypłaty. Sprawdź, czy masz jakieś wstrzymania lub zadłużenie z powodu zwrotów/storna w {link1}.",
				"feesReturnsHoldbacksLink1": "ostatni plik rozliczenia",
				"notPaidOrder": {
					"scheduleFollowed": "Po przyjęciu zamówienia wypłacimy kwotę na Twoje konto bankowe zgodnie z harmonogramem wypłat. Opłaty, zwroty i inne koszty zostaną odjęte od tej kwoty. Sprawdź wartość wypłaty w swoim {link1}.",
					"scheduleFollowedLink1": "ostatni plik rozliczenia",
					"noHoldback": "Sprawdź, czy masz zarejestrowane właściwe dane konta bankowego dla waluty wypłaty {link1}.",
					"noHoldbackLink1": "tutaj",
					"withHoldback": "Jeśli wartość przyjętych zamówień przewyższa zadłużenie, prosimy o sprawdzenie, czy masz zarejestrowane właściwe dane konta bankowego dla waluty wypłaty {link1}.",
					"withHoldbackLink1": "tutaj"
				},
				"whenPaidOrderNext": {
					"scheduleFollowed": "Kolejną wypłatę otrzymasz zgodnie z harmonogramem wypłat + opóźnienie wypłat."
				},
				"changePaymentFrequency": {
					"isAble": "Skontaktuj się z naszym wsparciem za pośrednictwem poniższych kanałów.",
					"isUnable": "Niestety nie spełniasz wymagań, aby zmienić swój harmonogram wypłat."
				},
				"orders": {
					"uncapturedDynamicYes": "Widzę, że masz nieprzyjęte zamówienia – {number} szt.",
					"uncapturedDynamicNo": "Widzę, że nie masz nieprzyjętych zamówień",
					"uncapturedYesPart1": "Czas zatem przyjąć kilka zamówień! W tym celu",
					"uncapturedYesPart2": "1. Przejdź do strony Zamówienia, {link1}.",
					"uncapturesYesPart2Link1": "klikając tutaj",
					"uncapturedYesPart3": "2. Kliknij odnośnik Klarna do zamówienia, które chcesz przyjąć",
					"uncapturedYesPart4": "3. Wybierz artykuły lub dodaj kwotę, którą chcesz przyjąć",
					"uncapturedYesPart5": "4. Wciśnij „Przyjmij”",
					"uncapturedNoPart1": "Aby przyjąć zamówienie, musisz najpierw mieć zamówienia do przyjęcia.",
					"uncapturedNoPart2": "W przyjmowaniu zamówienia chodzi o potwierdzenie, że zamówienie zostało wysłane do klienta. Należy to zrobić zawsze w tym samym dniu, w którym zamówienie jest wysyłane, dla każdego zamówienia. Kiedy przyjmujesz zamówienie, dajesz nam również znać, że powinniśmy uruchomić wypłatę dla Ciebie za to zamówienie. Przeczytaj więcej o tym, jak przyjąć zamówienie {link1}.",
					"uncapturedNoLink1": "tutaj",
					"customerCreditPaymentMethodNo": "Niestety nie możemy przedłużyć zamówienia, którego termin ważności upłynął. Trzeba będzie odtworzyć zamówienie.",
					"expirationDateSurpassedYes": "Pozwól nam pomóc Ci w przedłużeniu zamówienia i skontaktuj się z naszym wsparciem poprzez jeden z poniższych kanałów.",
					"expirationDateSurpassedNo": "Przejdź do {link1}. Wybierz zamówienie, zaznaczając pole obok numeru referencyjnego Klarna. Kliknij Przedłuż termin ważności i potwierdź swój wybór.",
					"expirationDateSurpassedNoLink1": "Zamówienia > Do przyjęcia",
					"isOrderCapturedYesPart1": "Wybierz artykuły, za które chcesz dokonać zwrotu pieniędzy i kliknij Zwrot pieniędzy. Możesz również najpierw kliknąć Zwrot pieniędzy, a następnie wprowadzić kwotę, za którą chcesz dokonać zwrotu – samodzielnie wybierasz, który sposób jest dla Ciebie najlepszy.",
					"isOrderCapturedYesPart2": "Twój klient otrzyma zwrot kwoty, którą już zapłacił w ciągu 2-5 dni roboczych. Ta kwota zostanie odjęta od Twojej następnej wypłaty.",
					"isOrderCapturedNo": "Jeśli masz nieprzyjęte zamówienie, którego nie wyślesz, możesz je całe {link1}. Przejdź do {link2} i kliknij Anuluj zamówienie.",
					"isOrderCapturedNoLink1": "anulować",
					"isOrderCapturedNoLink2": "strony zamówienia",
					"refundPartiallyCaptured": "Jeśli zamówienie przyjęto jedynie częściowo, dla wysłanych artykułów, i nie zrealizujesz pozostałej części zamówienia, należy zwolnić jego nieprzyjętą część. Przejdź do {link1}, kliknij Więcej działań i wybierz Zwolnij.",
					"refundPartiallyCapturedLink1": "strony zamówienia"
				}
			},
			"messages": {
				"sorryToHearThat": "Przykro mi, że nie udało mi się pomóc. Wkrótce przekieruję Cię do naszej obsługi technicznej."
			},
			"button": {
				"label": "Uzyskaj wsparcie"
			},
			"contact": {
				"chat": "Czat z agentem",
				"ticket": "Prześlij zgłoszenie",
				"times": {
					"minutes": "Czas oczekiwania: {time} min.",
					"hours": "Czas oczekiwania: {time} godz.",
					"days": "Czas oczekiwania: {time} d."
				}
			}
		}
	}
};